<div class="profile-page">
  <app-hero-profile [firstName]="(user$ | async)?.firstName" [hasSubscription]="hasSubscription" [content]="content">
  </app-hero-profile>

  <div class="profile-page__content" *ngIf="(user$ | async) as user">
    <app-current-plan *ngIf="hasSubscription" [currentSubscription]="subscription" [content]="content">
    </app-current-plan>

    <app-test-result-profile
      *ngIf="(testResult$ | async) as testResult"
      [testResult]="testResult"
      [content]="content?.fields.testResult"
    >
    </app-test-result-profile>

    <ng-container *ngIf="hasSubscription === false">
      <ng-container *ngIf="user.testResult">
        <app-title-and-ingress-banner [content]="content?.fields.choosePlanTitleAndIngress" [paddingBottom]="false">
        </app-title-and-ingress-banner>
        <app-choose-plan [content]="content?.fields.choosePlan"></app-choose-plan>
      </ng-container>

      <ng-container *ngIf="!user.testResult">
        <app-title-ingress-and-cta-banner
          [content]="content?.fields.noSubscriptionAndNoTestResultCta"
          [boxWithBackground]="true"
        >
        </app-title-ingress-and-cta-banner>

        <app-title-and-ingress-banner [content]="content?.fields.howCompensateWorksTitleAndIngress">
        </app-title-and-ingress-banner>

        <app-how-compensate-works [content]="content?.fields.howCompensateWorks"></app-how-compensate-works>
      </ng-container>
    </ng-container>

    <app-invite [content]="content?.fields.invite"></app-invite>
    <app-sitra-banner [content]="content?.fields.sitraTips"></app-sitra-banner>
    <app-where-money-goes [content]="content?.fields.whereMoneyGoes"></app-where-money-goes>
  </div>

  <!--<ng-container *ngIf="(shareUrl$ | async) as url">
    <h1>Invite</h1>
    <label for="copy">Invite your friends:</label>
    <br />
    <input id="copy" (click)="copyShareUrl()" [value]="url" />
    <br />
    <span *ngIf="shareUrlCopied">Copied!</span>
  </ng-container>
  <pre *ngIf="(invitations$ | async) as invitees">
    {{ invitees | json }}
  </pre>-->
</div>
